import Image from 'next/image';
import Link from 'next/link';
import style from './index.module.scss';

interface ITechnologyIconProps {
  title: string;
  width: string;
  height: string;
  iconSrc: string;
  link?: string;
}

export const TechnologyIcon = ({ title, width, height, iconSrc, link }: ITechnologyIconProps) => {
  const content = (
    <div className={`${style.technology__image}`}>
      <Image loading="lazy" src={iconSrc} width={width} height={height} alt={title} />
      <div className={`${style.technology__hover}`}>{title}</div>
    </div>
  );

  if (link) {
    return (
      <Link href={link} prefetch={false}>
        <a className={`${style.technology}`}>{content}</a>
      </Link>
    );
  }

  return <div className={`${style.technology}`}>{content}</div>;
};
